<app-view #view [code]="'views.edit'" [model]="item" (onEvent)="onEvent($event)"></app-view>